module.exports = "/static/media/auth_top_logo.02ef0149.svg";